export default __webpack_public_path__ + "static/value-9030c2a27bafde41538b0cd991183162.svg";